const version = require("./package.json").version;

const defaults = {
  cloud: "production",
  api: {
    baseUri: "https://api.racepointenergy.com",
    searchUri: "https://cprd1-app.savant.com/search",
    syncSiteIndexEndpoint: "/site-index/sync/pages",
    syncSFDocumentsEndpoint: "/site-index/sync/docs",
    searchEndpoint: "/site-index/search",
  },
  decap: {
    enabled: false,
  },
  salesforce: {
    captchaV2PubKey: "6Ldqk_wlAAAAACewi34BiF4bpDtjBuymkHMCgqoC",
    captchaV3PubKey: "6LenQuUlAAAAAL6sd-A5t3xIjKqc-NDI3oijYojp",
    webToLead: {
      uri: "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8",
      utm: {
        utmSource: "00N700000036Eaf",
        utmMedium: "00N700000036EaV",
        utmCampaign: "00N700000036Ea6",
        utmContent: "00N700000036EaL",
      },
      projectIntake: {
        oid: "00D700000008MFO",
        keyname: "savant_com_ReCaptchaV2",
        serviceRequest: "0124u000000UV5i",
        first_name: "first_name",
        last_name: "last_name",
        email: "email",
        phone: "phone",
        country: "country",
        state: "state",
        city: "city",
        professional_identity: "00N70000002EhG6",
        description: "description",
        powerInterest: "00N4u000004XcGJ",
        lightingInterest: "00N4u000004XcGG",
        entertainmentInterest: "00N4u000004XcGH",
        shadesInterest: "00N4u000004XcGE",
        networkingInterest: "00N4u000004XcGI",
        securityInterest: "00N4u000004XcGF",
        policyAgreement: "00N4u000004XcGO",
        homeID: "00N4u000004joZr",
        dealerID: "00N4u000004joZq",
        hasSavantSystem: "00N4u000004Dhdb",
        rebatesInterest: "00NUP0000011ov3",
        rebatesRecordType: "012UP000004jjoH",
      },
      powerProject: {
        recordType: "0124u000000YWd6",
        oid: "00D700000008MFO",
        project_name: {
          id: "00N4u000003mDVj",
          value: "power project",
        },
        first_name: "first_name",
        last_name: "last_name",
        email: "email",
        phone: "phone",
        country: "country",
        state: "state",
        city: "city",
        professional_identity: "00N70000002EhG6",
        description: "description",
        policyAgreement: "00N4u000004XcGO",
        hasSavantSystem: "00N4u000004Dhdb",
      },
      becomeADealer: {
        recordType: "012700000009pLL",
        oid: "00D700000008MFO",
        smartHome: "00N4u000003mEBV",
        highVoltageInstallationOrElectricalContractor: "00N4u000003mEBR",
        solarInstallation: "00N4u000003mEBW",
        hvacInstallation: "00N4u000003mEBQ",
        otherFocus: "00N4u000003mEBT",
        resellEnergySolutions: "00N4u000003mEBN",
        batteryStorageSystems: "00N4u000003mEBM",
        pvSolarSystems: "00N4u000003mEBU",
        evChargingSystems: "00N4u000003mEBO",
        loadManagementSystems: "00N4u000003mEBP",
        backupGenerators: "00N4u000003mEBL",
        otherEnergySolutions: "00N4u000003mEBS",
      },
    },
    webToCase: {
      uri: "https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8",
      savantCallback: {
        oid: "00D700000008MFO",
      },
    },
    intWebToCase: {
      uri: "https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8",
      supportForms: {
        oid: "00D700000008MFO",
      },
    },
  },
  siteURL: "https://www.savant.com",
  version,
};

module.exports = defaults;
